import type { SVGProps } from "react";
export interface CarSideElectricIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CarSideElectricIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CarSideElectricIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M.875 16.5V13c0-1.408.932-2.598 2.212-2.989l.754-3.019.1-.338a4.12 4.12 0 0 1 3.902-2.779h5.302c1.557 0 2.99.87 3.69 2.273l1.886 3.778a5.125 5.125 0 0 1 4.404 5.075v1.5A3.125 3.125 0 0 1 20 19.624h-.5a1.125 1.125 0 0 1 0-2.25h.5a.875.875 0 0 0 .875-.875V15A2.875 2.875 0 0 0 18 12.126c-.426 0-.815-.241-1.006-.623l-2.172-4.349a1.87 1.87 0 0 0-1.677-1.028H7.843c-.812 0-1.518.512-1.774 1.26l-.045.152-.933 3.736c-.125.5-.575.852-1.091.852a.875.875 0 0 0-.875.874v3.5c0 .483.392.875.875.875h.5l.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006H4A3.125 3.125 0 0 1 .875 16.5m13.624.875.116.006a1.125 1.125 0 0 1 0 2.238l-.116.006H9.5a1.125 1.125 0 0 1 0-2.25z"
      />
      <path
        fill={color}
        d="M8.375 18.5a1.375 1.375 0 1 0-2.75 0 1.375 1.375 0 0 0 2.75 0m10 0a1.376 1.376 0 1 0-2.752.002 1.376 1.376 0 0 0 2.752-.002M9.993 7.498a1.125 1.125 0 1 1 2.013 1.005l-.686 1.372h1.18a1.125 1.125 0 0 1 1.006 1.627l-1.5 3a1.125 1.125 0 0 1-2.013-1.004l.686-1.373h-1.18a1.125 1.125 0 0 1-1.006-1.627zm.631 11.002a3.625 3.625 0 1 1-7.25.001 3.625 3.625 0 0 1 7.25-.001m10.001 0a3.626 3.626 0 1 1-7.252 0 3.626 3.626 0 0 1 7.252 0"
      />
    </svg>
  );
}
